export const en = {
  ra: {
    action: {
      add_filter: 'Add filter',
      add: 'Add',
      back: 'Go Back',
      bulk_actions: '%{smart_count} selected',
      cancel: 'Cancel',
      clear_input_value: 'Clear value',
      clone: 'Clone',
      confirm: 'Confirm',
      create: 'Create',
      delete: 'Delete',
      edit: 'Edit',
      export: 'Export',
      list: 'List',
      refresh: 'Refresh',
      remove_filter: 'Remove this filter',
      remove: 'Remove',
      save: 'Save',
      search: 'Search',
      show: 'Show',
      sort: 'Sort',
      undo: 'Undo',
      unselect: 'Unselect',
      expand: 'Expand',
      close: 'Close',
      open_menu: 'Open menu',
      close_menu: 'Close menu',
    },
    boolean: {
      true: 'Yes',
      false: 'No',
      null: ' ',
    },
    page: {
      create: 'Create %{name}',
      dashboard: 'Dashboard',
      edit: '%{name} #%{id}',
      error: 'Something went wrong',
      list: '%{name}',
      loading: 'Loading',
      not_found: 'Not Found',
      show: '%{name} #%{id}',
      empty: 'No %{name} yet.',
      invite: 'Do you want to add one?',
    },
    input: {
      file: {
        upload_several: 'Drop some files to upload, or click to select one.',
        upload_single: 'Drop a file to upload, or click to select it.',
      },
      image: {
        upload_several: 'Drop some pictures to upload, or click to select one.',
        upload_single: 'Drop a picture to upload, or click to select it.',
      },
      references: {
        all_missing: 'Unable to find references data.',
        many_missing: 'At least one of the associated references no longer appears to be available.',
        single_missing: 'Associated reference no longer appears to be available.',
      },
      password: {
        toggle_visible: 'Hide password',
        toggle_hidden: 'Show password',
      },
    },
    message: {
      about: 'About',
      are_you_sure: 'Are you sure?',
      bulk_delete_content:
        'Are you sure you want to delete this %{name}? |||| Are you sure you want to delete these %{smart_count} items?',
      bulk_delete_title: 'Delete %{name} |||| Delete %{smart_count} %{name}',
      delete_content: 'Are you sure you want to delete this item?',
      delete_title: 'Delete %{name} #%{id}',
      details: 'Details',
      error: 'A client error occurred and your request could not be completed.',
      invalid_form: 'The form is not valid. Please check for errors',
      loading: 'The page is loading, just a moment please',
      no: 'No',
      not_found: 'Either you typed a wrong URL, or you followed a bad link.',
      yes: 'Yes',
      unsaved_changes: "Some of your changes weren't saved. Are you sure you want to ignore them?",
    },
    navigation: {
      no_results: 'No results found',
      no_more_results: 'The page number %{page} is out of boundaries. Try the previous page.',
      page_out_of_boundaries: 'Page number %{page} out of boundaries',
      page_out_from_end: 'Cannot go after last page',
      page_out_from_begin: 'Cannot go before page 1',
      page_range_info: '%{offsetBegin}-%{offsetEnd} of %{total}',
      page_rows_per_page: 'Rows per page:',
      next: 'Next',
      prev: 'Prev',
    },
    auth: {
      auth_check_error: 'Please login to continue',
      user_menu: 'Profile',
      username: 'Username',
      password: 'Password',
      sign_in: 'Sign in',
      sign_in_error: 'Authentication failed, please retry',
      logout: 'Logout',
    },
    notification: {
      updated: 'Element updated |||| %{smart_count} elements updated',
      created: 'Element created',
      deleted: 'Element deleted |||| %{smart_count} elements deleted',
      bad_item: 'Incorrect element',
      item_doesnt_exist: 'Element does not exist',
      http_error: 'Server communication error',
      data_provider_error: 'dataProvider error. Check the console for details.',
      i18n_error: 'Cannot load the translations for the specified language',
      canceled: 'Action canceled',
      logged_out: 'Your session has ended, please reconnect.',
    },
    validation: {
      required: 'Required',
      minLength: 'Must be %{min} characters at least',
      maxLength: 'Must be %{max} characters or less',
      minValue: 'Must be at least %{min}',
      maxValue: 'Must be %{max} or less',
      number: 'Must be a number',
      email: 'Must be a valid email',
      oneOf: 'Must be one of: %{options}',
      regex: 'Must match a specific format (regexp): %{pattern}',
    },
  },
  resources: {
    users: {
      name: 'User |||| Users',
      fields: {
        id: 'ID',
        username: 'Username',
        first_name: 'First Name',
        last_name: 'Last Name',
        language_code: 'Language',
        is_blacklisted: 'Blacklisted',
        total_bets: 'Total Bets',
        total_wagered: 'Total Wagered',
        total_won: 'Total Won',
        created_at: 'Registered',
        last_active: 'Last Active',
      },
      actions: {
        ban: 'Ban User',
        unban: 'Unban User',
      },
    },
    transactions: {
      name: 'Transaction |||| Transactions',
      fields: {
        id: 'ID',
        user_id: 'User ID',
        event_id: 'Event ID',
        amount: 'Amount',
        currency: 'Currency',
        tx_type: 'Type',
        tx_hash: 'Transaction Hash',
        status: 'Status',
        created_at: 'Created',
        completed_at: 'Completed',
        error_message: 'Error Message',
      },
      types: {
        prize_payout: 'Prize Payout',
        escrow_payment: 'Escrow Payment',
        escrow_refund: 'Escrow Refund',
      },
      status: {
        PENDING: 'Pending',
        COMPLETED: 'Completed',
        FAILED: 'Failed',
        REFUNDED: 'Refunded',
      },
      actions: {
        retry: 'Retry Payment',
        refund: 'Issue Refund',
      },
    },
    'statistics/users': {
      name: 'User Statistics',
      fields: {
        user_id: 'User ID',
        username: 'Username',
        total_events: 'Total Events',
        total_bets: 'Total Bets',
        total_wagered: 'Total Wagered',
        total_won: 'Total Won',
        win_rate: 'Win Rate',
        avg_bet: 'Avg Bet',
        biggest_win: 'Biggest Win',
      },
    },
    'statistics/owners': {
      name: 'Owner Statistics',
      fields: {
        owner_id: 'Owner ID',
        username: 'Username',
        total_events_created: 'Events Created',
        total_participants: 'Total Participants',
        total_prize_pool: 'Total Prize Pool',
        avg_participants_per_event: 'Avg Participants',
        active_events: 'Active Events',
      },
    },
    'support/tickets': {
      name: 'Ticket |||| Support Tickets',
      fields: {
        id: 'Ticket ID',
        user_id: 'User ID',
        subject: 'Subject',
        category: 'Category',
        priority: 'Priority',
        status: 'Status',
        assigned_to: 'Assigned To',
        created_at: 'Created',
        updated_at: 'Updated',
        resolved_at: 'Resolved',
      },
      categories: {
        technical: 'Technical',
        payment: 'Payment',
        account: 'Account',
        event: 'Event',
        other: 'Other',
      },
      priorities: {
        low: 'Low',
        medium: 'Medium',
        high: 'High',
        urgent: 'Urgent',
      },
      status: {
        OPEN: 'Open',
        IN_PROGRESS: 'In Progress',
        RESOLVED: 'Resolved',
        CLOSED: 'Closed',
      },
      actions: {
        assign: 'Assign to Me',
        reply: 'Reply',
        resolve: 'Resolve',
        close: 'Close',
      },
    },
    'admin-users': {
      name: 'Admin User |||| Admin Users',
      fields: {
        id: 'ID',
        username: 'Username',
        email: 'Email',
        role: 'Role',
        role_id: 'Role',
        is_active: 'Active',
        last_login: 'Last Login',
        created_at: 'Created',
      },
      actions: {
        reset_password: 'Reset Password',
        deactivate: 'Deactivate',
        activate: 'Activate',
      },
    },
    roles: {
      name: 'Role |||| Roles',
      fields: {
        id: 'ID',
        name: 'Name',
        description: 'Description',
        permissions: 'Permissions',
        created_at: 'Created',
        updated_at: 'Updated',
      },
      permissions: {
        users_view: 'View Users',
        users_edit: 'Edit Users',
        users_delete: 'Delete Users',
        transactions_view: 'View Transactions',
        transactions_manage: 'Manage Transactions',
        support_view: 'View Support Tickets',
        support_manage: 'Manage Support Tickets',
        admin_users_view: 'View Admin Users',
        admin_users_manage: 'Manage Admin Users',
        roles_view: 'View Roles',
        roles_manage: 'Manage Roles',
        settings_view: 'View Settings',
        settings_edit: 'Edit Settings',
        audit_view: 'View Audit Log',
        statistics_view: 'View Statistics',
      },
    },
    settings: {
      name: 'Setting |||| Settings',
      fields: {
        key: 'Setting Key',
        value: 'Value',
        description: 'Description',
        updated_at: 'Last Updated',
        updated_by: 'Updated By',
      },
      keys: {
        maintenance_mode: 'Maintenance Mode',
        api_rate_limit: 'API Rate Limit',
        max_file_size: 'Max File Size',
        session_timeout: 'Session Timeout',
        email_notifications: 'Email Notifications',
        xrocket_api_enabled: 'xRocket API Enabled',
      },
    },
    'audit-log': {
      name: 'Audit Log Entry |||| Audit Log',
      fields: {
        id: 'ID',
        admin_user_id: 'Admin User',
        action: 'Action',
        resource: 'Resource',
        resource_id: 'Resource ID',
        changes: 'Changes',
        ip_address: 'IP Address',
        user_agent: 'User Agent',
        created_at: 'Timestamp',
      },
      actions: {
        CREATE: 'Created',
        UPDATE: 'Updated',
        DELETE: 'Deleted',
        LOGIN: 'Logged In',
        LOGOUT: 'Logged Out',
        BAN_USER: 'Banned User',
        UNBAN_USER: 'Unbanned User',
        RESET_PASSWORD: 'Reset Password',
      },
    },
  },
  custom: {
    dashboard: {
      title: 'Dashboard',
      welcome: 'Welcome to Casino Admin Panel',
      metrics: {
        total_users: 'Total Users',
        active_users: 'Active Users',
        total_transactions: 'Total Transactions',
        revenue_24h: 'Revenue (24h)',
        revenue_7d: 'Revenue (7d)',
        revenue_30d: 'Revenue (30d)',
      },
      charts: {
        volume_over_time: 'Transaction Volume Over Time',
        token_distribution: 'Token Distribution',
        user_activity: 'User Activity',
        recent_activity: 'Recent Activity',
      },
    },
    notifications: {
      password_reset_success: 'Password reset successfully',
      password_reset_error: 'Failed to reset password',
      user_banned: 'User banned successfully',
      user_unbanned: 'User unbanned successfully',
      transaction_retried: 'Transaction retry initiated',
      transaction_refunded: 'Refund processed successfully',
      ticket_assigned: 'Ticket assigned successfully',
      ticket_resolved: 'Ticket resolved successfully',
      settings_updated: 'Settings updated successfully',
    },
    errors: {
      database_error: 'Database error occurred. Please try again.',
      network_error: 'Network error. Please check your connection.',
      unauthorized: 'You are not authorized to perform this action.',
      not_found: 'The requested resource was not found.',
      validation_error: 'Please check your input and try again.',
      server_error: 'Server error occurred. Please contact support.',
    },
  },
};
